// extracted by mini-css-extract-plugin
export default {"box":"Scan_box__+HoSM","details":"Scan_details__yoaAb","code":"Scan_code__wmgWj","button":"Scan_button__chB8d"};